module.exports = __webpack_public_path__ + "static/media/ReportPromedio.d353b94f.svg";